package org.vreo.devicehub.features.core.data.device.dto

import kotlinx.serialization.Serializable

/**
 * Direct device request dto. request from client to forward messages to device.
 *
 * @property deviceId device id to forward messages to.
 * @property messages list of messages to be sent to device.
 */
@Serializable
data class DirectDeviceRequestDto(
    val deviceId: String,
    val messages: List<String>
)